import { fromFetch } from 'rxjs/fetch';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { authwsEnvironment } from './authws-environment';
import { migrationStatusSchema } from './schemas/migration-status.schema';

export function postMigrationStatus(email: string) {
  return fromFetch(
    new Request(authwsEnvironment.tidMigrationStatusUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      body: JSON.stringify({
        email,
      }),
    })
  ).pipe(selectData(migrationStatusSchema));
}
